import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

const script = () => {
	// Media slider
	new Swiper(".media-slider .swiper-container", {
		slidesPerView: "auto",
        releaseOnEdges: true,
        forceToAxis: true
	});

    // Custom cursor when hovering
	let mouseCursor = document.querySelector(".cursor");
	let mediaSlider = document.querySelector(".media-slider .swiper-container");
    let mouseCursorText = document.querySelector(".cursor p span");

	mediaSlider.addEventListener("mousemove", function (e) {
		mouseCursor.style.top = e.pageY + "px";
		mouseCursor.style.left = e.pageX + "px";
		mouseCursor.classList.add("active");

        // Overflow text apparition
        mouseCursorText.classList.add("anim");
	});

	mediaSlider.addEventListener("mouseleave", () => {
		mouseCursor.classList.remove("active");

        // Overflow text remove
        mouseCursorText.classList.remove("anim");
	});
};

exports.script = script;
